import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { ApiCall } from '../helper/axios';
import { formatPrice, getUserToken } from '../helper/commonFunction';
import OnlineStripePopup from '../pages/common-popup/OnlineStripePopup';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
    .catch((error) => {
        console.error('Stripe.js failed to load — payments unavailable:', error);
        return null;
    });

const StripeWrapper = ({
    show,
    setShow,
    totalPrice,
    showDiscounts,
    extraChargePrice,
    queryParams,
    bookingOtherData,
    selectPaymentMethod,
    onineServicesFees,
    agentActiveCurrency,
    onPaymentSuccess,
    onClose,
    ndcPriceAfterHold,
    checkPriceBeforeBooking,
    displayPrice,
    isExcursion = false
}) => {
    const [clientSecret, setClientSecret] = useState('');
    const [loading, setLoading] = useState(false);
    const userToken = getUserToken();
    const [totalAmount, setTotalAmount] = useState(totalPrice);

    useEffect(() => {
        if (!totalPrice || totalPrice === 0) {
            if(queryParams?.status !== 'HOLD'){
                return;
            }
        }

        let calculatedTotalPrice = showDiscounts ? parseFloat(totalPrice) : (parseFloat(totalPrice) + parseFloat(extraChargePrice?.total || 0) + parseFloat(extraChargePrice?.seat || 0)) ;
        if (queryParams?.status === 'HOLD') {
            calculatedTotalPrice = bookingOtherData?.totalPriceInfo?.totalFare;
            if (bookingOtherData?.totalPriceInfo?.couponData?.finalAmount) {
                calculatedTotalPrice = bookingOtherData?.totalPriceInfo?.couponData?.finalAmount;
            }
            if(queryParams?.source === 'ndc-portal'){
                calculatedTotalPrice = ndcPriceAfterHold;
            }
        }
        let onlineServiceFeeAmount = 0;
        if (selectPaymentMethod === 1) {
            onlineServiceFeeAmount = ((calculatedTotalPrice * onineServicesFees) / 100)
            calculatedTotalPrice += onlineServiceFeeAmount;
        }
        if(checkPriceBeforeBooking?.showForm || checkPriceBeforeBooking?.onlineForm)  {
            calculatedTotalPrice = checkPriceBeforeBooking?.amount?.originalAmount
        }
        calculatedTotalPrice = isExcursion ? calculatedTotalPrice : calculatedTotalPrice;
        setTotalAmount(calculatedTotalPrice)
        if (show && calculatedTotalPrice) {
            const fetchClientSecret = async () => {
                setLoading(true);
                try {
                    const response = await ApiCall(
                        'POST',
                        '/get-payment-secret',
                        { totalPrice: calculatedTotalPrice , currency : "AED"?.toLowerCase() },
                        { authorization: userToken }
                    );
                    if (response?.data?.statusCode === 200) {
                        setClientSecret(response?.data?.data?.clientSecret);
                    }
                } catch (error) {
                    console.error('Error fetching payment secret:', error);
                } finally {
                    setLoading(false);
                }
            };
            fetchClientSecret();
        }
    }, [show, totalPrice, userToken, showDiscounts, extraChargePrice, queryParams, bookingOtherData, selectPaymentMethod, onineServicesFees, agentActiveCurrency, checkPriceBeforeBooking]);

    const handlePaymentSuccess = async (paymentMethod) => {
        if (onPaymentSuccess) {
            onPaymentSuccess(paymentMethod);
        }
    };

    const options = {
        clientSecret,
        appearance: {
            theme: 'stripe',
        },
    };

    return (
        <>
            {show && clientSecret && (
                <Elements options={options} stripe={stripePromise}>
                    <OnlineStripePopup
                        show={show}
                        setShow={setShow}
                        totalAmount={Number(totalAmount) || 0}
                        agentActiveCurrency={agentActiveCurrency}
                        onPaymentSuccess={handlePaymentSuccess}
                        onClose={onClose}
                        clientSecret={clientSecret}
                        displayPrice={displayPrice}
                    />
                </Elements>
            )}
        </>
    );
};

export default StripeWrapper;
